import { render, staticRenderFns } from "./ClaimReinsurance.vue?vue&type=template&id=d49251be&"
import script from "./ClaimReinsurance.vue?vue&type=script&lang=js&"
export * from "./ClaimReinsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports